<!-- <div (click)="onClickItem()">
    <div class="title border-bottom">
        <span class="ttl">{{item?.title}}</span>
        <div class="date d-flex justify-content-between">
            <span class="text-primary">{{item?.subtitle}}</span>
        </div>
    </div>
    <div class="bg-white">
        <p class="description">{{item?.description}}</p>
    </div>
</div> -->

    <div class="dashboard-card" [ngStyle]="{ 'background-color': item?.color ? item?.color : getRandomColor() }" (click)="onClickItem()">
        <i class="icon {{item?.icon}}" ></i>
        <span>{{ item?.title }}</span>
    </div>